<template>
  <div class="container" v-show="show" :style="{ height: windowHeight + 'px' }">
    <!-- <van-nav-bar
      title="查询结果"
      left-text=""
      left-arrow
      fixed
      placeholder
      @click-left="onClickLeft"
    /> -->

    <van-card
      style="text-align: left; background-color: rgba(247, 243, 249, 1)"
      :desc="desc"
      :title="title"
      :thumb="img"
    >
      <template #bottom>
        <van-button
          class="searchBtn"
          @click="showDetails"
          round
          plain
          type="info"
          >查看详情</van-button
        >
      </template>
    </van-card>

    <div class="info">
      <div class="label">— 卡券信息 —</div>
      <van-cell
        style="text-align: left"
        v-for="item in voucherInfo"
        :key="item.voucherTitle"
        :title="item.voucherTitle"
        v-show="item.show"
      >
        <template #extra>
          <label :style="{ color: item.color }">{{ item.voucherValue }}</label>
        </template>
      </van-cell>
    </div>

    <van-action-sheet v-model="isDetailsShow" title="详细内容">
      <img :src="img" style="width: 100%; height: 100%" />
      <div
        style="
          text-align: left;
          margin: 20px 0 20px 15px;
          font-size: 20px;
          font-weight: 500;
        "
      >
        {{ title }}
      </div>
      <div style="text-align: left; margin: 0 0 20px 15px; font-size: 15px">
        {{ desc }}
      </div>
    </van-action-sheet>

    <van-dialog
      v-model="isReceiveShow"
      title="卡券兑换码"
      :before-close="onBeforeClose"
      @confirm="confirm"
      show-cancel-button
    >
      <van-field
        v-model="password"
        type="text" 
        label="卡券兑换码"
        placeholder="请输入卡券兑换码"
      />
    </van-dialog>

    <van-button
      v-if="voucherState == 3"
      class="bottomBtn"
      type="danger"
      @click="showOrderDetails"
      >查看订单</van-button
    >
    <van-button
      v-if="voucherState == 2"
      class="bottomBtn"
      type="danger"
      @click="receive"
      >立即领取</van-button
    >
  </div>
</template>

<script>
import api from "../../common/js/api";
export default {
  data() {
    return {
      id: -1, //卡券id
      isWechat:false, //是否是微信浏览器环境
      voucherCode: "", //卡券编码
      title: "", //商品标题
      desc: "", //描述信息
      img: "", //商品图片
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      voucherState: 1, //卡券状态
      isDetailsShow: false, //是否显示详情弹窗
      isReceiveShow: false, //是否显示领取兑换码弹窗
      password: "", //卡券兑换码
      show: true, //是否显示全部内容，提示空卡时不显示
      voucherInfo: [
        {
          voucherTitle: "卡券状态",
          voucherValue: "",
          color: "green",
          show: true,
        },
        {
          voucherTitle: "卡券编码",
          voucherValue: this.$route.query.voucherCode,
          color: "grey",
          show: true,
        },
        {
          voucherTitle: "订单编号",
          voucherValue: "",
          color: "black",
          show: true,
        },
        {
          voucherTitle: "卡券面值",
          voucherValue: "",
          color: "black",
          show: true,
        },
        {
          voucherTitle: "有效期",
          voucherValue: "",
          color: "grey",
          show: true,
        },
      ], //卡券信息
    };
  },

  components: {},

  computed: {},

  created() {
    this.voucherCode = this.$route.query.voucherCode;
    this.getData();
  },

  mounted() {

    //判断是否是微信浏览器环境
    const ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      this.isWechat = true;
    }


  },

  methods: {
    //获取页面数据
    getData() {
      this.$post(api.getByCardNo, {
        cardNo: this.$route.query.voucherCode,
      }).then((res) => {
        //status=1，表示未绑卡，=2表示已经绑卡，=3表示已经领取
        if (res.success) {
          this.id = res.data.id;
          switch (res.data.status) {
            case 1:
              this.showError("该卡为空卡，请联系客服");
              break;
            case 2:
              this.voucherState = 2;
              this.$set(this.voucherInfo[2], "show", false);
              this.bindVoucherInfo(res, "待领取");
              break;
            case 3:
              this.voucherState = 3;
              this.bindVoucherInfo(res, "已领取");
              break;
          }
        } else {
          this.showError(res.message);
        }
      });
    },
    //绑定卡券信息
    bindVoucherInfo(res, state) {
      this.img = res.data.options.picture;
      this.title = res.data.options.title;
      this.desc = res.data.options.info;
      this.$set(this.voucherInfo[0], "voucherValue", state);
      this.$set(this.voucherInfo[1], "voucherValue", res.data.cardNo);
      this.$set(this.voucherInfo[2], "voucherValue", res.data.orderNo);
      this.$set(
        this.voucherInfo[3],
        "voucherValue",
        "¥" + res.data.options.value
      );
      this.$set(this.voucherInfo[4], "voucherValue", res.data.options.indate);
    },
    showError(msg) {
      this.show = false;
      this.$dialog
        .alert({
          title: "错误",
          message: msg,
        })
        .then(() => {
          this.$router.replace("/");
        });
    },
    //返回
    onClickLeft() {
      this.$router.replace("/");
    },
    //查看详情
    showDetails() {
      this.isDetailsShow = true;
    },
    //立即领取
    receive() {
      this.isReceiveShow = true;
    },
    //输入领取兑换码后确认
    confirm() {
      if (this.password === "") {
        this.$toast("请输入卡券兑换码");
      } else {
        //后台验证兑换码
        this.$post(api.check, { id: this.id, code:this.$md5(this.password) }).then(
          (res) => {
            console.log(res);
            if (res.success && res.message == "兑换码正确") {
              this.$router.push({
                path: "/address",
                query: {
                  voucherCode: this.voucherCode,
                  id: this.id,
                  code: this.$md5(this.password),
                },
              });
            } else {
              this.$toast(res.message);
            }
          }
        );
      }
    },
    //查看订单详情
    showOrderDetails() {
      this.$router.replace({
        path: "/orderDetails",
        query: { voucherCode: this.$route.query.voucherCode,isShowReceive:true },
      });
    },
    //输入兑换码弹窗关闭前的事件
    onBeforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        this.password = "";
        return done();
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.container {
  width: 100%;
  background-color: rgba(247, 243, 249, 1);
  .searchBtn {
    width: 60%;
    margin: 50px 0 20px 0;
  }
  .info {
    background-color: white;
    .label {
      text-align: center;
      font-size: 20px;
      padding: 20px 0 20px 0;
      font-weight: 500;
    }
  }
  .bottomBtn {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>